export const texts = {
  id: (id: number) => `ID: ${id}`,
  copyId: "Copiar ID",
  copiedTitle: "ID copiado",
  copiedDescription: "El ID ha sido copiado al portapapeles",
  profile: "Perfil",
  notifications: "Notificaciones",
  history: "Historial",
  withdrawals: "Retiros",
  logout: "Cerrar sesión",
  unreadBadge: (count: number) => `${count} notificaciones sin leer`
} as const
